import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

function initSwiperTestimonials() {
    document.querySelectorAll('[data-js="slider-testimonials"]').forEach((el) => {
        if (el.swiperTestimonialsInstance) return;

        el.swiperTestimonialsInstance = new Swiper(el, {
            slidesPerView: 'auto',
            spaceBetween: 24,
            grabCursor: true,
            centeredSlides: false,
            watchOverflow: true,
            touchEventsTarget: 'container',

            breakpoints: {
                0:    { spaceBetween: 16 },
                1024: { spaceBetween: 24 },
            },

            navigation: {
                prevEl: el.querySelector('[data-js="slider-testimonials-prev"]'),
                nextEl: el.querySelector('[data-js="slider-testimonials-next"]'),
            },
        });
    });
}

document.addEventListener('DOMContentLoaded', initSwiperTestimonials);
window.addEventListener('load', initSwiperTestimonials);
